import script from "./CouponPackageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponPackageList.vue?vue&type=script&setup=true&lang=ts"

import "./CouponPackageList.vue?vue&type=style&index=0&id=081e52d2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081e52d2"]])

export default __exports__